var map = {
	"./babyshop.svg": [
		"./src/assets/images/babyshop.svg",
		"src_assets_images_babyshop_svg"
	],
	"./centrepoint.svg": [
		"./src/assets/images/centrepoint.svg",
		"src_assets_images_centrepoint_svg"
	],
	"./error.svg": [
		"./src/assets/images/error.svg?740e",
		"src_assets_images_error_svg"
	],
	"./homebox.svg": [
		"./src/assets/images/homebox.svg",
		"src_assets_images_homebox_svg"
	],
	"./homecentre.svg": [
		"./src/assets/images/homecentre.svg",
		"src_assets_images_homecentre_svg"
	],
	"./lifestyle.svg": [
		"./src/assets/images/lifestyle.svg",
		"src_assets_images_lifestyle_svg"
	],
	"./logo.svg": [
		"./src/assets/images/logo.svg",
		"src_assets_images_logo_svg"
	],
	"./max.svg": [
		"./src/assets/images/max.svg",
		"src_assets_images_max_svg"
	],
	"./shoeexpress.svg": [
		"./src/assets/images/shoeexpress.svg",
		"src_assets_images_shoeexpress_svg"
	],
	"./shoemart.svg": [
		"./src/assets/images/shoemart.svg",
		"src_assets_images_shoemart_svg"
	],
	"./shukran.svg": [
		"./src/assets/images/shukran.svg?bfef",
		"src_assets_images_shukran_svg"
	],
	"./splash.svg": [
		"./src/assets/images/splash.svg",
		"src_assets_images_splash_svg"
	],
	"./success.svg": [
		"./src/assets/images/success.svg?7c68",
		"src_assets_images_success_svg"
	],
	"./warning.svg": [
		"./src/assets/images/warning.svg?7747",
		"src_assets_images_warning_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/assets/images lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;